// Value of `IframeMessageType.GTM_EVENT` from the app's gz types, inlined to
// avoid a package -> app dependency.
const GTM_EVENT_TYPE = 'gtmEvent';

type DataLayerEvent = {
  [key: string]: unknown;
  event: string;
  eventLabel?: string;
};

declare global {
  interface Window {
    dataLayer: DataLayerEvent[];
  }
}

export const trackEvent = (event: string, data: Record<string, unknown>) => {
  if (typeof window !== 'undefined') {
    const gzContext = (window as Window & { iframeGZContext?: { consentGranted?: boolean } }).iframeGZContext;

    // GZ iframe context: drop events if consent not granted
    if (gzContext && gzContext.consentGranted !== true) {
      return;
    }

    const cleanData = Object.fromEntries(Object.entries(data).filter(([_, value]) => value !== undefined));

    const eventPayload: DataLayerEvent = {
      event,
      eventLabel: (data.eventLabel as string | undefined) ?? '',
      ...cleanData,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventPayload);

    const parentIFrame = (window as Window & { parentIFrame?: { sendMessage: (message: unknown) => void } })
      .parentIFrame;

    if (parentIFrame) {
      parentIFrame.sendMessage({ type: GTM_EVENT_TYPE, data: eventPayload });
    }
  }
};
